import React from "react"

export interface LayoutContextType {
  headerHeight: number
}

const LayoutContext = React.createContext<LayoutContextType>({
  headerHeight: 0
})

const appLayout: LayoutContextType = {
  headerHeight: 92
}

export const DefaultLayoutContextProvider = React.memo(
  ({ children }: { children: React.ReactNode }) => (
    <LayoutContext.Provider value={appLayout}>
      {children}
    </LayoutContext.Provider>
  )
)
